import { useMemo, useState } from 'react'
// ui components
import { Input } from 'baseui/input';
import { Block } from 'baseui/block';
import { useStyletron } from 'baseui';
import { LoadingView } from '../../components'
import { AlarmListItem } from './AlarmListItem'
import { ViewSelector } from './ViewSelector'
// api
import { useActiveAlarms } from '../../hooks/useActiveAlarms'
import { useIntl } from 'react-intl';
import { VscFilter } from 'react-icons/vsc';
import RenderIfVisible from 'react-render-if-visible';
import { AlarmDetailsDto } from '../../services/alarm';
import { groupBy } from '../../utils/arrayUtils';


export const AlarmList = () => {

  const intl = useIntl();
  const [css, theme] = useStyletron();
  const { items: alarms, error, isLoading, isSuccess } = useActiveAlarms()

  const [search, setSearch] = useState("");
  const onSearchChanged = (e: any) => setSearch(e.target.value)

  const grouped = useMemo(() => {
    // filter alarms
    const filtered = alarms?.slice()?.filter((a) => a.object.description ? a.object.description?.toLowerCase().includes(search.toLowerCase()) : search === '') ?? []
    const grouped = groupBy(filtered,getKey).map(v => { return { count:  v.values.length, first: v.values.slice().sort((a,b) => a.onTime - b.onTime)[0], values: v.values }});
    return grouped;
  }, [alarms, search])


  return (
    <>
      <div className={css({ position: 'relative' })}>
        <Block display='flex' gridGap='20px' flexDirection='row' alignItems='center'>
          <Input
            startEnhancer={<VscFilter />}
            placeholder={intl.formatMessage({ id: `filterByKeyword`, defaultMessage: "Filter by keyword" })}
            onChange={onSearchChanged}
          />
          <ViewSelector></ViewSelector>
        </Block>

        <div className={css({ display: 'flex', marginTop: theme.sizing.scale500 })}>
          <div className={css({ flex: '1 1 auto', height: '80vh' })}>
            <LoadingView error={error} isLoading={isLoading} isSucess={isSuccess}>
              {grouped?.map((alarm, idnex) => (<>
                <RenderIfVisible defaultHeight={100} visibleOffset={500} stayRendered>
                  <AlarmListItem count={alarm.count} alarms={alarm.values} key={alarm.first.id}></AlarmListItem>
                </RenderIfVisible>
              </>))

              }
            </LoadingView>
          </div>
        </div>
      </div>
    </>
  )
}

function getKey(item: AlarmDetailsDto) {
  return `${item.objectId}_${item.propertyName}`
}


